import Departamentos from 'pages/departamentos/List';
import DepartamentosView from 'pages/departamentos/View';
import DepartamentosAdd from 'pages/departamentos/Add';
import DepartamentosEdit from 'pages/departamentos/Edit';
import Empresas from 'pages/empresas/List';
import EmpresasView from 'pages/empresas/View';
import EmpresasAdd from 'pages/empresas/Add';
import EmpresasEdit from 'pages/empresas/Edit';
import EstoqueList from 'pages/estoque/List';
import EstoqueEdit from 'pages/estoque/Edit';
import Funcionarios from 'pages/funcionarios/List';
import FuncionariosView from 'pages/funcionarios/View';
import FuncionariosAdd from 'pages/funcionarios/Add';
import FuncionariosEdit from 'pages/funcionarios/Edit';
import Funcoes from 'pages/funcoes/List';
import FuncoesView from 'pages/funcoes/View';
import FuncoesAdd from 'pages/funcoes/Add';
import FuncoesEdit from 'pages/funcoes/Edit';
import Grupos from 'pages/grupos/List';
import GruposAdd from 'pages/grupos/Add';
import GruposEdit from 'pages/grupos/Edit';
import PedidoitensList from 'pages/pedidoitens/List';
import PedidoitensAdd from 'pages/pedidoitens/Add';
import PedidoitensEdit from 'pages/pedidoitens/Edit';
import Pedidos from 'pages/pedidos/List';
import PedidosAdd from 'pages/pedidos/Add';
import PedidosEdit from 'pages/pedidos/Edit';
import ProdutogruposList from 'pages/produtogrupos/List';
import ProdutogruposAdd from 'pages/produtogrupos/Add';
import ProdutogruposEdit from 'pages/produtogrupos/Edit';
import Produtos from 'pages/produtos/List';
import ProdutosAdd from 'pages/produtos/Add';
import ProdutosEdit from 'pages/produtos/Edit';
import RolesList from 'pages/roles/List';
import RolesView from 'pages/roles/View';
import RolesAdd from 'pages/roles/Add';
import RolesEdit from 'pages/roles/Edit';
import Setores from 'pages/setores/List';
import SetoresView from 'pages/setores/View';
import SetoresAdd from 'pages/setores/Add';
import SetoresEdit from 'pages/setores/Edit';
import UsersList from 'pages/users/List';
import UsersView from 'pages/users/View';
import UsersAdd from 'pages/users/Add';
import UsersEdit from 'pages/users/Edit';
import DashboardAdmin from 'pages/custom/DashboardPage';
import Apuracao from 'pages/custom/Apuracao.List';
import KardexResumePage from 'pages/custom/KardexPageResume';
import Kardex from 'pages/custom/Kardex';
import DetailProdutoGrupos from 'pages/custom/DetailProdutoGrupos';
import GHE from 'pages/grupogestor/GHE';
import Dashboard1 from 'components/dashboards/Dashboard1';
import Permissions from 'pages/permissions/Permissions.List';
import LiberacoesTotem from 'pages/consultas/liberacoestotem';
import ProdutosConsumo from 'pages/produtos/List.Consumo';
import ImportData from 'pages/admin/ImportData';

export const routeComponentMap = {
    Apuracao,
    Dashboard1,
    DashboardAdmin,
    LiberacoesTotem,
    DepartamentosAdd,
    DepartamentosEdit,
    Departamentos,
    DepartamentosView,
    DetailProdutoGrupos,
    EmpresasAdd,
    EmpresasEdit,
    Empresas,
    EmpresasView,
    EstoqueEdit,
    EstoqueList,
    FuncionariosAdd,
    FuncionariosEdit,
    Funcionarios,
    FuncionariosView,
    Funcoes,
    FuncoesAdd,
    FuncoesEdit,
    FuncoesView,
    GHE,
    GruposAdd,
    GruposEdit,
    Grupos,
    Kardex,
    PedidoitensAdd,
    PedidoitensEdit,
    PedidoitensList,
    PedidosAdd,
    PedidosEdit,
    Pedidos,
    Permissions,
    ProdutogruposAdd,
    ProdutogruposEdit,
    ProdutogruposList,
    ProdutosAdd,
    ProdutosEdit,
    Produtos,
    RolesAdd,
    RolesEdit,
    RolesList,
    RolesView,
    SetoresAdd,
    SetoresEdit,
    Setores,
    SetoresView,
    UsersAdd,
    UsersEdit,
    UsersList,
    UsersView,
    ProdutosConsumo,
    ImportData
};

export function getComponentByName(name) {
    const lowerName = name.toLowerCase();
    const key = Object.keys(routeComponentMap).find(
        (k) => k.toLowerCase() === lowerName
    );
    return key ? routeComponentMap[key] : undefined;
}